type CommunityListPanelProps = {
  children: React.ReactNode;
};

export const CommunityListPanel = (props: CommunityListPanelProps) => {
  return (
    <div className='w-full mb-4 bg-white rounded-xl p-4 border border-gray-100'>
      {props.children}
    </div>
  );
};
